import {
  Controller,
  Get,
  Param,
  Post,
  Body,
  Put,
  Delete,
  Query,
} from '@nestjs/common';
import { FinancialsService } from './financials.service';
import { CreateFinancialsDto, UpdateFinancialsDto } from '@crm/dto';
import { ApiResponseInterface } from '@crm/interface';

@Controller('financials')
export class FinancialsController {
  constructor(private readonly financialsService: FinancialsService) {}

  // GET /financials
  @Get()
  async getAll(): Promise<ApiResponseInterface> {
    return this.financialsService.getAll();
  }

  // GET /financials/user/:userId
  @Get('user/:userId')
  async getByUserId(@Param('userId') userId: string): Promise<ApiResponseInterface> {
    return this.financialsService.getByUserId(userId);
  }

  // GET /financials/:id
  @Get(':id')
  async getById(@Param('id') id: string): Promise<ApiResponseInterface> {
    return this.financialsService.getById(id);
  }

  // POST /financials
  @Post()
  async create(@Body() dto: CreateFinancialsDto): Promise<ApiResponseInterface> {
    return this.financialsService.create(dto);
  }

  // PUT /financials
  @Put()
  async update(@Body() dto: UpdateFinancialsDto): Promise<ApiResponseInterface> {
    return this.financialsService.update(dto);
  }

  // DELETE /financials
  @Delete()
  async softDelete(@Body() dto: UpdateFinancialsDto): Promise<ApiResponseInterface> {
    return this.financialsService.softDelete(dto);
  }
}